import CelebrateWinComponent from "slotworks/components/celebrate-win/celebrate-win-component";
import Layers from "slotworks/graphics/layers/layers";
import gameState from "slotworks/model/game-state";
import LineResult from "slotworks/model/gameplay/records/results/line-result";
import settingsModel from "slotworks/model/settings/settings-model";

export default class HarleyCelebrateWinComponent extends CelebrateWinComponent {

    public totalWin(win: number) {
        const noWin = settingsModel.isUKJurisdiction() && !gameState.getCurrentGame().isWinAboveBet();
        if (!noWin)
            Layers.Custom.get("Coins").getParticle("coin").emit = true;
        return super.totalWin(win);
    }

    public singleTotalWin(win: number, result: LineResult) {
        const noWin = settingsModel.isUKJurisdiction() && !gameState.getCurrentGame().isWinAboveBet();
        if (!noWin)
            Layers.Custom.get("Coins").getParticle("coin").emit = true;
        return super.singleTotalWin(win, result);
    }
}